import React from 'react'
import PropTypes from 'prop-types'
import FavoriteBorder from '@mui/icons-material/FavoriteBorder'

const FavoriteBorderIcon = ({ height, width, ...more }) => {
	
	return (
		<FavoriteBorder
			height={height}
			width={width}
			{...more}
		/>
	)
}

FavoriteBorderIcon.propTypes = {
	height: PropTypes.number.isRequired,
	width: PropTypes.number.isRequired
}

export default FavoriteBorderIcon
